import styled from 'styled-components'

import { ListItem } from 'src/components/Ant'

const WrapDivMeta = styled.div`
  align-items: center;
  display: flex;
  height: 200;
  justify-content: center;
  width: 200;
`

const WrapListItem = styled(ListItem)<{ isselected?: number }>`
  border-radius: '4px';
  border: '1px dashed rgb(232, 232, 232)';
  padding: '0 6px';
  ${({ isselected }) => {
    if (isselected) {
      return { backgroundColor: '#b7eb8f' }
    }
  }}
`

const WrapText = styled.span<{ isselected?: boolean }>`
  background-color: #f0f0f0;
  font-size: 14px;
  margin-bottom: 2px;
  padding: 2px;
  width: 100%;
  ${({ isselected }) =>
    isselected
      ? {
          color: '#52c41a',
          fontWeight: 'bolder'
        }
      : {
          color: '#999999'
        }}
`

export { WrapDivMeta, WrapListItem, WrapText }
